module.exports = __webpack_public_path__ + "static/media/loading-blue.2900aeb2.svg";